import * as z from "zod"

import { ISODateScheme, ISODateTimeScheme } from "@p-ban/common/src/zodCustomScheme"

import httpClient from "../httpClient"

export const END_POINT = {
  MAINTENANCE: "/kiban/api/schedule/maintenance",
  RECEIVABLE_DATES: "/kiban/api/schedule/receivable-dates",
  CHINESE_NEW_YEAR: "/kiban/api/schedule/chinese-new-year",
} as const

const scheme = {
  maintenance: z.tuple([ISODateTimeScheme, ISODateTimeScheme]).or(z.tuple([z.null(), z.null()])),
  receivableDates: z.array(ISODateScheme),
  chineseNewYear: z.tuple([ISODateScheme, ISODateScheme]).or(z.tuple([z.null(), z.null()])),
}

const scheduleApi = {
  maintenance() {
    return httpClient.get(END_POINT.MAINTENANCE, { transform: (data) => scheme.maintenance.parse(data) })
  },
  receivableDates() {
    return httpClient.get(END_POINT.RECEIVABLE_DATES, { transform: (data) => scheme.receivableDates.parse(data) })
  },
  chineseNewYear() {
    return httpClient.get(END_POINT.CHINESE_NEW_YEAR, { transform: (data) => scheme.chineseNewYear.parse(data) })
  },
} as const

export default scheduleApi
